import type { LifecycleStatus, PaymentStatus } from '../types';

const LIFECYCLE_LABEL: Record<LifecycleStatus, string> = {
  draft: 'Concept',
  confirmed: 'Bevestigd',
  arrived: 'Aangekomen',
  no_show: 'No-show',
  cancelled: 'Geannuleerd',
};

const PAYMENT_LABEL: Record<PaymentStatus, string> = {
  none: 'Geen',
  pending: 'In afwachting',
  paid: 'Betaald',
  refunded: 'Terugbetaald',
  failed: 'Mislukt',
  unpaid: 'Nog niet betaald',
};

export function LifecyclePill({ status }: { status: LifecycleStatus }) {
  return (
    <span className={`pill pill-lc-${status}`}>
      {LIFECYCLE_LABEL[status] ?? status}
    </span>
  );
}

export function PaymentPill({ status }: { status: PaymentStatus }) {
  return (
    <span className={`pill pill-pay-${status}`}>
      {PAYMENT_LABEL[status] ?? status}
    </span>
  );
}
